import React from 'react';
import './IBLModalLoader.css';
import { IBLSpinLoader } from '../IBLSpinLoader';
import { useTranslation } from 'react-i18next';

interface IBLModalLoaderProps {
  backgroundColor?: string;
  loaderSize?: number;
  displayText?: string;
  displayTextColor?: string;
  displayTextSize?: string;
  loaderColor?: string;
}

export const IBLModalLoader: React.FC<IBLModalLoaderProps> = ({
  backgroundColor = '#FFFFFF',
  loaderSize = 40,
  displayText = 'Loading...',
  displayTextColor = '#888',
  displayTextSize = '16px',
  loaderColor = '',
}) => {
  const { t } = useTranslation('library');

  return (
    <div
      className="modal-loader-container"
      style={{ backgroundColor: backgroundColor }}
    >
      <div className="modal-loader-content">
        <div className="modal-loader-icon-box">
          <IBLSpinLoader color={loaderColor} size={loaderSize} />
        </div>
        <h5
          style={{ color: displayTextColor, fontSize: displayTextSize }}
          className="modal-loader-heading"
        >
          {displayText}
        </h5>
      </div>
    </div>
  );
};
